import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import CommonButton from '../../../common-button/CommonButton';

import scss from './Toolbar.module.scss';

const Toolbar = ({ buttons, extraClass }) => {
  const { t } = useTranslation();

  return (
    <div className={clsx(scss.toolbar, extraClass && extraClass)}>
      {buttons.map((button, i) => (
        <CommonButton
          styleColor='secondary'
          className={scss.button}
          onClick={button.handler}
          disabled={button.disabled}
          key={`Button-${i}`}>
          {t(button.text)}
        </CommonButton>
      ))}
    </div>
  );
};

export default Toolbar;
